export default __webpack_public_path__ + "static/media/startup3.26ec7744.gif";